<template>
  <div class="cjdsq">
    <Header title="成绩单申请" type="0" route="/cjdsq/index"></Header>
    <div class="sqly-all">
      <div class="sqly">
        <van-field
          v-model="sqly"
          required
          label="申请理由"
          placeholder="请输入"
          type="textarea"
          rows="12"
          autosize
          class="custom"
        />
      </div>
      <van-field
        v-model="shr.mc"
        label="审核人"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="show1 = true"
        readonly
      />
    </div>
    <div class="footer">
      <van-button class="foot" type="default" @click="cancel">取消</van-button>
      <van-button class="foot-bm" type="default" @click="tjSub">申请</van-button>
    </div>
    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default{
  data(){
    return{
      sqly:'',
      shr: {},
      show1: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      reset:'',
      resetId:''
    }
  },
  created() {
    this.getShr()
  },
  methods:{
    async getShr() {
      let concatList2 = [];
      const params = {
        ywcode: "628",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    },
    cancel(){
      this.$router.push({ path: "/cjdsq/index" });
    },
    async tjSub(){
      if (JSON.stringify(this.shr) == "{}") {
        this.$toast.fail("请选择送审审核人!");
        return;
      }
      if (this.sqly == "") {
        this.$toast.fail("请填写完整申请原因!");
        return;
      }
      const res = await Api.getCjdsqSave({
        bz: this.sqly,
        userIds: this.shr.dm,
        id: ''
      });
      if (res.code == 1) {
        this.$toast.success("保存并申请成功!");
        setTimeout(() => {
          this.$router.replace("/cjdsq/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
  }
}
</script>
<style lang="less" scoped>
.cjdsq{
  width: 100%;
  height: 100%;
  background: #f0f0f2;
  padding-top:0.63rem;
  box-sizing: border-box;
  .sqly-all{
    margin:0 0.73rem;
  }
  .sqly{
    border-radius: 0.6rem;
    margin-bottom: 0.5rem;
    .custom{
      flex-direction: column;
      align-items: stretch;
    }
    .custom .van-field_label{
      display: block;
      margin-bottom: 8px;
    }
  }
}
/* 审核人 */
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person {
  padding: 15px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}

.apply-pop .person .per-btn {
  background-color: #ecedfd;
  color: #7469f8;
}
.person .cur {
  background-color: #7469f8;
  color: #ecedfd;
}
.footer{
  width: 100%;
  padding:0.63rem 0;
  box-sizing: border-box;
  background: #fff;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  .foot{
    width: 40%;
    height: 3.13rem;
    border-radius: 1.56rem !important;
  }
  .foot-bm{
    width: 40%;
    height: 3.13rem;
    background: #7469F8;
    color:#fff;
    border-radius: 1.56rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/cjdsq/sq.vue